import _ from 'lodash';
import URI from 'urijs';

export function afterSignInPathFor(user) {
  let fallback = '/';

  if (!user)                 return fallback
  else if (user.isStudent)   return '/students/home'
  else if (user.isTeacher)   return '/teachers/home'
  else if (user.isParent)    return '/parents/children'
  else if (user.isSuperuser) return '/admin/students'
  else                       return fallback
}

export function afterSignInRedirect(user, history) {
  const path = afterSignInPathFor(user)

  if (user && user.isSuperuser) { window.location.href = path }
  else {
    history.replace(path)
  }
}
